import { render, staticRenderFns } from "./BusinessUnitDetailsTableItem.vue?vue&type=template&id=0bdeb7eb&"
import script from "./BusinessUnitDetailsTableItem.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitDetailsTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports